import axios from "axios";
import qs from 'qs'
import { baseUrlApis, isPathMatchValidPage, isMobile, msForTeamsAppApi } from './index';
import { store } from "Store/store.index";
//import intl from 'react-intl-universal'
import {
  PHANTOMONLINE_GLOBAL_CONFIG,
  URL_CWS_API,
  IS_NEED_AB_ROLE,
} from './constants';
import { BOTTOM_AD_SHOWED } from '../constants/local.constant'
import { getQueryVariable, storageGetItem, storageSetItem, storageClear, storageRemoveItem, prop, updateProp, windowActionFn, saveClientRequestStatusToCache, getClientRequestStatusFromCache  } from '../utils/utils';
import { WEBSDK_LOCAL_KEYS } from '../app.config';
import { ItemsKey as SECURITY_POLICIES_ITEMS } from '../components/dialogs/SecurityPolicies/utils';
import { teamsServerBaseUrl } from "@/modules/msTeams/apis/foxit";
import { sharePointGASender } from "@/store/services/GoogleAnalyticsSender";

// code safety: ONLINERD-1158
/**
 * 1. localStorage.getItem(key) => storageGetItem, storageSetItem, storageClear, storageRemoveItem ...
 * 2. window.open => windowAction(window, 'open', args);

 */
export default class LoginApis {
  constructor() {
  }
  cleanStorage = (isLoginOut) => {
    //cookies.set(USER_CURRENT_TOKEN,'', { path: '/' });
    //cookies.remove(USER_CURRENT_TOKEN, { path: '/' });
    let caches = {};
    const keys = [
      PHANTOMONLINE_GLOBAL_CONFIG,
      BOTTOM_AD_SHOWED,
      SECURITY_POLICIES_ITEMS,
      'fx__browser_monitor_id',
      'fx_pwa_show_tag',
      'user-temp-trial',
      'SignUpSuccessUsers',
      'hasfirstOpenFile',
      'hasFirstEnter',
      'config-timestamp',
      'PREFERENCES-DOCUMENTS',
      'PREFERENCES-GENNERAL',
      'language',
      'formPreference',
      'fx-contextmenu-form-field-props',
      'GoogleDriveAccessToken',
      'OneDriveAccessToken',
      'BoxAccessToken',
      'DropBoxAccessToken',
      'isSystemlanguage',
      'annot-custom-color',
      'isLoginOut',
      'aiPreference',
      'driveTokenInfo',
      // FIXME Why delete all the storage and then save the ones you want to keep?
      // When you want to save it but you have to come to the configuration, Is it so stupid?
      // Could I just delete the ones that should be deleted?
      // ONLINERD-8683
      'is_f_in',
      'customToolbar',
      'tk_er',
      'new_update_log_name',
      'stripe_s_i',
      'search_check_config',
      'DISMISS_EDU_GUIDE_POPUP',
      'navigation-key',
      'e-sign-china-initiate-sign-flow_tooltip',
      'esign_tab_tooltip',
      ...WEBSDK_LOCAL_KEYS,
      'euUserList',
      'IsPWAInstalled',
        'toolTip_esignTabCN',
        'ESIGN_CHINA_NAVIGATION_FIRST',
        'ESIGN_CHINA_FIRST_IN',
      'PaperCheckLegalNoticeInfoDialogDisplayedMap',
      'CurrentESignAccountIdMap',
      'FoxitEsignTabTooltipShowMap',
      'SignatureStyleTipShowMap',
      'ApplyAllSignatureTooltipShowMap',
      'CUSTOM-STAMPS'
    ]
    const loginOutCleanKeys = [
      // 'GoogleDriveAccessToken'
    ]

    keys.forEach((key) => {
      let value = storageGetItem(localStorage, key);

      if (isLoginOut) {
        if (value !== null && loginOutCleanKeys.indexOf(key) < 0) {
          caches[key] = value;
        }
      } else if (value !== null) {
          caches[key] = value;
      }
    })

    storageClear(localStorage);
    storageClear(sessionStorage);

    keys.forEach((key) => {
      let value = caches[key];
      if (value !== null && value !== void 0) {
        storageSetItem(localStorage, key, value);
      }
    })
    return;

  };
  deleteToken = async () => {
    let CPDFURI;
    try {
      CPDFURI = store.appStore.accountUrl;
    } catch (error) {
      throw error;
    }
    let data = {
      'access_token': store.userStore.token,
    }
    let url = `${CPDFURI}/api/users/access_token`;
    try {
      let result = await axios.delete(url, { data });
      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: UserApis -> deleteToken -> error", error)
      return Promise.resolve(error);
    }
  }
  removeParamFromUrl = (searchParam, params) => {
    if (!searchParam) return '';

    let searchPart = "";
    let searchWithOutTicket = searchParam.replace(/^\?/, "");
    let pathName = prop(location, 'pathname')// window.location.pathname
    params.forEach((param) => {
      let re = new RegExp(param + '=[\\w-]*', "g");
      searchWithOutTicket = searchWithOutTicket.replace(re, "").replace(/^\&/, "");
    })
    //searchWithOutTicket = searchParam.replace(/ticket=[\w-]*/g, "").replace("?", "");
    let urlParamsArr = searchWithOutTicket.split("&");
    if (urlParamsArr.length > 0) {
      searchPart = urlParamsArr
        .join("&")
        .replace(/^&/, "?")
        .replace(/&$/, "");
    }
    if (searchPart.length > 0 && searchPart.indexOf("?") === -1) {
      searchPart = "?" + searchPart;
    }
    if (pathName === "/invite-sign-up") {
      searchPart = "";
    }
    return searchPart;
  }

  getHostUrlWithoutTicket = () => {
    return this.getCasService(null, true, true, true);
  }
  getHostUrlForSSO = () => {
    return this.getCasService(null, true, true, false, ['ticket', 'isSSO', 'enterpriseId'])
  }
  getHostUrlForOfficeAddIn = () => {
    return this.getCasService(null, true, true, false, ['from'])
  }

  getServiceByCWSTicket = (useNewWindow) => {
    let host = prop(location, 'protocol') + "//" + prop(location, 'host');
    let pathName = prop(location, 'pathname');
    let casService = '';
    const isSSO = getQueryVariable('isSSO')

    if (useNewWindow) {
      const inTeams = store.teamsAppStore.inTeamsApp
      pathName =  inTeams ? '/sites/sign-success-for-teams-task.html' : '/sites/sign-success.html'
      casService = encodeURIComponent(host + pathName);
      return casService;
    }

    if (isSSO === 'true') {
      casService = this.getCasService(true, false, false, false, ['ticket'])
    } else {
      casService = this.getCasService(true, false, false, true);
    }

    return casService;
  }

  makeCurrentUrlSearch = (searchVal, filterParams, toCas, onlyRemoveTicket) => {
    let srcSearch;
    let searchs = '';
    let dstList = [];
    srcSearch = searchVal.replace(/^\?/, '');
    do {
      filterParams.forEach((param) => {
        let re = new RegExp(param + '=[\\w-]*', 'g');
        srcSearch = srcSearch.replace(re, '').replace(/^\&/, '').replace(/\&\&/, '&');
      })
      if (onlyRemoveTicket) {
        let re = new RegExp('ticket' + '=[\\w-]*', 'g');
        searchs = srcSearch.replace(re, '').replace(/^\&/, '').replace(/\&\&/, '&').replace(/\&$/, '');
        break;
      }
      let srcList = srcSearch.split('&');

      srcList.forEach((item) => {
        if (!item) return;
        dstList.push(item);
      })

    } while (false);

    if (dstList.length > 0) {
      searchs = dstList.join('&');
    }
    searchs = searchs.replace(/^&/, '?').replace(/&$/, '');
    if (searchs.length > 0 && searchs.indexOf('?') === -1) {
      searchs = '?' + searchs;
    }
    return searchs;
  }
  getCasService = (useCurrentWindow, returnObject, noEncode, onlyRemoveTicket, filters) => {
    let host = prop(location, 'protocol') + "//" + prop(location, 'host');
    let pathName = prop(location, 'pathname');
    let searchParam = prop(location, 'search');
    let casService;
    // falls through means use the same code block, and no warning when build
    if (pathName === '/') {
      pathName = '';
    } else if (!isPathMatchValidPage(pathName)) {
      pathName = '';
      if (searchParam.indexOf('action') !== -1) {
        casService = encodeURIComponent(host + pathName);
      }
    }

    if (casService) {
      return casService;
    }

    // search
    let searchUri;

    filters = filters || ['ticket', 'role', 'enterpriseId', 'remember-me', 'remember_me', 'fbclid', 'opentype'];

    if (onlyRemoveTicket) filters = ['ticket', 'role', 'enterpriseId', 'remember-me', 'remember_me'];
    searchUri = this.makeCurrentUrlSearch(prop(window.location, 'search'), filters, false, onlyRemoveTicket);

    if (!!searchUri && pathName === '') {
      pathName = '/';
    }
    if (returnObject) {
      return { host, pathname: pathName, search: searchUri };
    }

    casService = host + pathName + searchUri;
    if (noEncode) {
      return casService;
    }
    casService = encodeURIComponent(casService);
    return casService;
  };

  getLoginUrl = (useNewWindow, params, servicePath = '/sites/sign-success.html') => {
    if (!params) {
      params = {}
    }

    let host = prop(location, 'protocol') + "//" + prop(location, 'host');
    let uri = this.getCasService(!useNewWindow, false, true, false);
    let email = getQueryVariable('email');
    let server_config = getQueryVariable('server_config');
    const { full } = store.appStore.lng;
    const isWindowsOS = store.appStore.isWindowsOS;
    const cTag = getQueryVariable('cTag') || 'WebPage'
    let hf = useNewWindow && (isWindowsOS || isMobile()) ? 0 : 1;
    let _default = {
      from: 'online',
      isEnterp: 1,
      al: full,
      an: 'Foxit PhantomPDF Online',
      av: '3.0.0.1',
      cv: '2.0.0.0',
      service: !useNewWindow ? uri : host + servicePath,
      hf,
      cTag,
      random: new Date().getTime()
    };

    store.userStore.updateCasService(encodeURIComponent(_default.service))

    email && (_default['email'] = email);
    server_config && (_default['server_config'] = server_config);
    let urlParams = Object.assign({}, _default, params)
    let request = qs.stringify(urlParams);
    let isGoToAccount = true;
    let isUseCWS = getQueryVariable('useCWS');
    if (isUseCWS) isGoToAccount = false;
    let url = '';
    const CWSURI = window[PHANTOMONLINE_GLOBAL_CONFIG].cwsApiUrl;
    if (!isGoToAccount) {
      url = `${CWSURI}/site/plugin-sign-in?${request}`;
    } else {
      // TODO
      let ACCOUNT_URL = store.appStore.accountUrl;
      if (!ACCOUNT_URL) {
        throw new Error('accountUrl is empty')
      }
      url = `${ACCOUNT_URL}/site/plugin-sign-in?${request}`;
    }
    return url;
  }
  getSignUpUrl = (useNewWindow, servicePath = '/sites/sign-success.html') => {
    let host = prop(location, 'protocol') + "//" + prop(location, 'host');
    let uri = this.getCasService(!useNewWindow, false, true);
    let CPDFURI = store.appStore.accountUrl;
    const { full } = store.appStore.lng;
    const isWindowsOS = store.appStore.isWindowsOS;
    const cTag = getQueryVariable('cTag') || 'WebPage'
    let hf = useNewWindow && (isWindowsOS || isMobile()) ? 0 : 1;
    let request = qs.stringify({
      from: 'online',
      isEnterp: 1,
      al: full,
      an: 'Foxit PhantomPDF Online',
      av: '3.0.0.1',
      cv: '2.0.0.0',
      //service: !useNewWindow ?uri + '/signup/success': host+ '/sites/sign-up-success.html'
      //service: !useNewWindow ?uri : host + '/sites/sign-up-success.html'
      service: !useNewWindow ? uri : host + servicePath,
      hf,
      cTag
    });

    let url = `${CPDFURI}/site/sign-up?${request}`;
    return url;
  }

  doPostMessageToParentWindow(MESSAGE_KEY, szParams) {
    //const MESSAGE_KEY = 'online.user.status';
    storageSetItem(localStorage, MESSAGE_KEY, szParams);
    let origin = baseUrlApis.getBaseUrl();
    var msg = {};
    msg[MESSAGE_KEY] = szParams;

    window.opener && window.opener.postMessage(msg, origin); // '*'
  }

  doListenSubWindowAction = (MESSAGE_KEY, callback, removeListener) => {
    //const MESSAGE_KEY = 'online.user.status';
    function clean() {
      storageRemoveItem(localStorage, MESSAGE_KEY);
      window.removeEventListener('message', onHandleWindowMessage);
      window.removeEventListener('storage', onHandleStorage);
    }
    function onHandleWindowMessage(event) {
      let origin = baseUrlApis.getBaseUrl();

      if (event.data[MESSAGE_KEY] && `${event.origin}/` === origin) {

        callback(event.data[MESSAGE_KEY])
        if (removeListener) clean()
      }
    }
    function onHandleStorage(e) {
      if (e.key === MESSAGE_KEY) {

        callback(e.newValue)
        if (removeListener) clean()
      }
    }
    window.addEventListener('message', onHandleWindowMessage, false);
    window.addEventListener('storage', onHandleStorage, false);
  }

  loginInNewWindow = (url, callback, onCloseWindow, type) => {
    const MESSAGE_KEY = 'online.msg';
    const width = 470;
    let left = (window.innerWidth - width) / 2;
    let _hTime = null;
    let _hWin = null;
    const isWindowsOS = store.appStore.isWindowsOS;

    let args = [url];
    if (isWindowsOS) {
      let height = 640;
      args = [url, 'PhantomOnline Sign In', `width=${width}, height=${height}, left=${left}, top=${(window.innerHeight - 500) / 2}`];
    }

    _hWin = windowActionFn(window, 'open', args);

    function onSignSuccess(szParams) {
      let msg = JSON.parse(szParams);
      callback && callback(msg);
    }
    function onHandleWindowMessage(event) {

      let origin = baseUrlApis.getBaseUrl();

      if (event.data[MESSAGE_KEY] && `${event.origin}/` === origin) {
        onSignSuccess(event.data[MESSAGE_KEY])
        clean(true);
      }
    }
    function onHandleStorage(e) {

      if (e.key === MESSAGE_KEY) {
        onSignSuccess(e.newValue)
        clean(true);
      }
    }
    function clean(notCloseLoading, cleanTrigger) {
      if (!_hWin) {

        return;
      }
      if (cleanTrigger === 'programInterval') {
        type === 'signup' && sharePointGASender.signUpFailed()
        type === 'login' && sharePointGASender.signInInterrupted()
      }

      _hWin.close();
      !notCloseLoading &&  onCloseWindow && onCloseWindow();
      _hWin = null;
      _hTime && clearInterval(_hTime); _hTime = null;
      storageRemoveItem(localStorage, MESSAGE_KEY);
      window.removeEventListener('message', onHandleWindowMessage);
      window.removeEventListener('storage', onHandleStorage);
    }
    // start to listen
    _hTime = setInterval(()=>{
      if(_hWin && _hWin.closed) {

        clean(false, 'programInterval');
      }
    }, 2000);

    window.addEventListener('message', onHandleWindowMessage, false);
    window.addEventListener('storage', onHandleStorage, false);
  }

  loginFn = (useNewWindow, callback, onCloseWindow, params) => {
    const inTeams = store.teamsAppStore.inTeamsApp;
    //mqqbrowser
    if (isMobile()) {
      let _userAgent = navigator.userAgent.toLowerCase();
      const list = ["mqqbrowser"]
      if (list.some(item => _userAgent.indexOf(item) !== -1))
        useNewWindow = false;
    }

    const isLoadConfig = () => {
      return !!storageGetItem(localStorage, PHANTOMONLINE_GLOBAL_CONFIG);
    }
    const fn = () => {
      let val = storageGetItem(localStorage, PHANTOMONLINE_GLOBAL_CONFIG);
      window[PHANTOMONLINE_GLOBAL_CONFIG] = JSON.parse(val);
      let url = this.getLoginUrl(useNewWindow, params, !inTeams?void 0 : "/sites/sign-success-for-teams-task.html");
      if (inTeams) {
        msForTeamsAppApi.signInAuth(msForTeamsAppApi.getTeamsSignInUrl()).then(callback).finally(onCloseWindow);
        return;
      }
      if (!useNewWindow) {
        updateProp(location, 'href', url) //window.location.href = url;
        return;
      }
      // to sign in new window
      this.loginInNewWindow(url, callback, onCloseWindow, 'login');
    }
    //prop(location, 'search') + "//" + prop(location, 'host')

    this.cleanStorage();
    if (isLoadConfig()) {
      return fn();
    }

    let timer = setInterval(() => {
      if (!isLoadConfig()) {
        return;
      }
      clearInterval(timer);
      fn();
    }, 500);
  }
  signUpFn = (useNewWindow, callback, onCloseWindow) => {
    this.cleanStorage();
    let timer = setInterval(() => {
      let val = storageGetItem(localStorage, PHANTOMONLINE_GLOBAL_CONFIG);
      if (!val) {
        baseUrlApis.loadUrlConfig();
        return;
      }
      clearInterval(timer);
      window[PHANTOMONLINE_GLOBAL_CONFIG] = JSON.parse(val);

      const inTeams = store.teamsAppStore.inTeamsApp;
      let url = this.getSignUpUrl(useNewWindow, !inTeams?void 0 : "/sites/sign-success-for-teams-task.html");
      if (inTeams) {
        msForTeamsAppApi.signInAuth(msForTeamsAppApi.getTeamsSignUpUrl()).then(callback).finally(onCloseWindow);
        return;
      }
      if (!useNewWindow) {
        updateProp(location, 'href', url) //window.location.href = url;
        return;
      }
      // to sign in new window
      this.loginInNewWindow(url, callback, onCloseWindow, 'signup');

    }, 500);
  }
  loginOutFn = (service, relogin, useNewWindow, params = {}) => {
    if (!service) {
      service = this.getCasService();
    }
    if (!service) {

      return;
    }
    if (!window[PHANTOMONLINE_GLOBAL_CONFIG]) {
      let szCfg = storageGetItem(localStorage, PHANTOMONLINE_GLOBAL_CONFIG);
      if (szCfg) {
        let cfg = JSON.parse(szCfg);
        window[PHANTOMONLINE_GLOBAL_CONFIG] = cfg;
      }
    }
    //window[PHANTOMONLINE_GLOBAL_CONFIG] = JSON.parse(val);
    let CASURI = window[PHANTOMONLINE_GLOBAL_CONFIG].casApiUrl;

    storageSetItem(localStorage, 'isLoginOut', true)
    this.cleanStorage(true);

    let targetUrl = ''
    if (relogin) {
      let loginService = this.getLoginUrl(useNewWindow)
      targetUrl = `${CASURI}/cas/logout?service=${encodeURIComponent(loginService)}`
    } else {
      const inTeams = store.teamsAppStore.inTeamsApp
      if (inTeams) {
        let targetUrl = `${CASURI}/cas/logout?service=${encodeURIComponent(location.origin + "/sites/sign-out-for-teams-task.html")}`
        const url = `${teamsServerBaseUrl}/tab/sign-out?service=${encodeURIComponent(targetUrl)}&t=${Date.now()}`;
        const { callback, onCloseWindow } = params;
        msForTeamsAppApi.signInAuth(url).then((data) => {
          callback && callback(data);
          isMobile() && location.reload();
        }).finally(onCloseWindow);
        return;
      }
      targetUrl = `${CASURI}/cas/logout?service=${service}&time=${Date.now()}`
    }
    if (!useNewWindow) {
      updateProp(location, 'href', targetUrl) //window.location.href = url;
      return;
    }
    //
    const { callback, onCloseWindow } = params;
    this.loginInNewWindow(targetUrl, callback, onCloseWindow);
  }

  getTokenByTicket = async (ticket, casService) => {
    const CPDFURI = store.appStore.accountUrl;
    let uri = CPDFURI + "/api/users/accessTokenBySt?casService=" + casService + "&casTicket=" + ticket + "&an=Foxit PhantomPDF Online";
    let result = await axios.get(uri);

    if (result && result.ret === 0) {
      return result.data.access_token;
    }
    throw result;
  };
  /**
  {
    "ret": 0,
    "message": "SUCCESS",
    "data": [
      {
        "cUserID": "5d785d7b36132d217ad37079",
        "userEmail": "test002@zetmail.com",
        "firstname": "Lan",
        "lastname": "XiuJu",
        "fullname": "",
        "avatar": "https://cws-fzk8s.connectedpdf.com/img/gravatar_default.png",
        "lastlogintime": null,
        "userMobile": "15960074660",
        "register_type": 1
      }
    ],
    "returned": 1
  }
   */
  getUserInfo = async (token, enterpriseId) => {
    /* var url;
    const {userStore} = store;
    var accessToken = userStore.token || await getToken() */
    let CPDFURI;
    try {
      CPDFURI = store.appStore.accountUrl;
    } catch (error) {
      throw error;
    }
    return
    try {
      let url = `${CPDFURI}/api/users?access-token=${token}&userNotifyType=1&bNeedABRole=${IS_NEED_AB_ROLE}`

      if (enterpriseId) {
        url = `${CPDFURI}/api/users?access-token=${token}&enterpriseId=${enterpriseId}&userNotifyType=1&bNeedABRole=${IS_NEED_AB_ROLE}`
      }

      const result = await axios.get(url).catch((err) => err);
      //let result = response?response.data:null;
      if (result && result.ret === 0) {
        let userInfo = result.data[0];
        userInfo['full_name'] = userInfo.fullname;
        store.accountStore.setUserABRole(userInfo.roleABTest);
        // store.accountStore.setUserABRole(1); // 0: A, 1: B
        return Promise.resolve(userInfo)
      }
      throw result;
    } catch (error) {
      throw error
      //  return Promise.reject({message:error})
    }
  }

  getUserJWT = async (token, from) => {
    let CPDFURI;
    try {
      CPDFURI = await baseUrlApis.getBaseUrlBy(URL_CWS_API);
    } catch (error) {
      throw error;
    }

    try {
      let url = `${CPDFURI}/cpdfapi/v1/users/jwt?usedFor=${from}&access-token=${token}`
      const result = await axios.get(url).catch((err) => err);
      return result;
    } catch (error) {
      throw error
      //  return Promise.reject({message:error})
    }
  }

  updateUserInfo = async ({ first_name, last_name, bUsedPPO, phone }) => {
    let CPDFURI = '';
    try {
      CPDFURI = store.appStore.accountUrl;
    } catch (error) {
      throw error;
    }
    //const { first_name, last_name, bUsedPPO } = params;
    let data = {};
    (first_name !== void 0) && (data['first_name'] = first_name);
    (last_name !== void 0) && (data['last_name'] = last_name);
    (bUsedPPO !== void 0) && (data['bUsedPPO'] = bUsedPPO);
    (phone !== void 0) && (data['phone_number'] = phone);
    const fd = qs.stringify(data);

    let url = `${CPDFURI}/api/users?access-token=${store.userStore.token}`;
    return Promise.resolve(false);
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    try {
      let result = await axios.put(url, fd, config);

      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: updateUserInfo -> error", error)
      return Promise.resolve(error);
    }
  }
  // GET /client/request-online
  getEnterpriseUserPermission = async (enterpriseId) => {
    let CPDFURI;
    try {
      CPDFURI = await baseUrlApis.getBaseUrlBy(URL_CWS_API);
    } catch (error) {
      throw error;
    }

    let request_csrf = new Date().getTime();
    let storageKeyPrefix = 'EnterpriseInfoCache';

    let request = qs.stringify({
      'access-token': store.userStore.token || store.userStore.tokenCache,
      enterpriseId: enterpriseId,
      dist: 'ONLINE',
      _csrf: request_csrf 
    });
    try {
      let _url = `${CPDFURI}/cpdfapi/v1/client/request?${request}`
      const result = await axios.get(_url).catch((err) => err);
      //let result = response?response.data:null;
      if (result && result.ret === 0) {

      }
      if (result) {
        let { ret } = result;
        if ((ret === 0) || (ret >=50000 && ret <= 59999)) {
          saveClientRequestStatusToCache(result, request_csrf, enterpriseId, storageKeyPrefix);
          return Promise.resolve(result)
        } else {
          return getClientRequestStatusFromCache(enterpriseId, storageKeyPrefix).then( res => {
            if (res) {
              return Promise.resolve(res)
            }
            return Promise.resolve(result)
          })
        }
      } else {
        return Promise.resolve(result)
      }
    } catch (error) {
      return getClientRequestStatusFromCache(enterpriseId, storageKeyPrefix).then( res => {
        if (res) {
          return Promise.resolve(res)
        }
        return Promise.resolve(error)
      })
    }
  }

  getTicket = async ({ email, url, token, userMobile }) => {
    let CPDFURI;
    try {
      CPDFURI = store.appStore.accountUrl;
    } catch (error) {
      throw error;
    }

    let data = {
      service: url,
      an: 'Foxit PhantomPDF Online'
    }

    if (email) {
      Object.assign(data, { userEmail: email })
    } else if (userMobile) {
      Object.assign(data, { userMobile })
    }

    let request = qs.stringify(data);
    try {
      let _url = `${CPDFURI}/api/users/get-cas-ticket?access-token=${token}&${request}`
      const result = await axios.get(_url).catch((err) => err);
      //let result = response?response.data:null;
      if (result && result.ret === 0) {

        let ticket = result.data['ticket'].st;
        return Promise.resolve(ticket)
      }
      throw result;
    } catch (error) {
      throw error
      //  return Promise.reject({message:error})
    }
  }

  modifyPassword = async ({ old_password, new_password }, token) => {
    let CPDFURI;
    try {
      CPDFURI = store.appStore.accountUrl;
    } catch (error) {
      throw error;
    }
    let url = `${CPDFURI}/api/users/password?access-token=${token}`;
    let data = qs.stringify({
      old_password,
      new_password
    });
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    try {
      let result = await axios.put(url, data, config);

      //let result = response?response.data:null;
      if (result && result.ret === 0) {
        // const data = result.data;

        //let token = data.access_token;
        return Promise.resolve(result);
      }
      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: ConvertApis -> modifyPassword -> error", error)
      return Promise.resolve(error);
    }
  }

  getCwsUrlByCancelAccount = async () => {
    let CPDFURI;
    try {
      CPDFURI = await baseUrlApis.getBaseUrlBy(URL_CWS_API);
    } catch (error) {
      throw error;
    }
    return CPDFURI;
  }

  // POST /cpdfapi/v1/users/access_token
  loginByApi = async ({ email, userMobile, password }) => {
    let CPDFURI;
    try {
      CPDFURI = store.appStore.accountUrl;
    } catch (error) {
      throw error;
    }
    let url = `${CPDFURI}/api/users/access_token`;
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    let data = {
      password,
    }

    if (email) {
      Object.assign(data, {email})
    } else if (userMobile) {
      Object.assign(data, {userMobile})
    }

    data = qs.stringify(data);
    try {
      let result = await axios.post(url, data, config);
      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: LoginApis -> getSurveyTask -> error", error)
      return Promise.resolve(error);
    }

  }
  updateUserNotify = async ({ userNotifyType, userNotifyStatus }) => {
    let CPDFURI = '';
    try {
      CPDFURI = store.appStore.accountUrl;
    } catch (error) {
      throw error;
    }
    let data = {};
    (userNotifyType !== void 0) && (data['userNotifyType'] = userNotifyType);
    (userNotifyStatus !== void 0) && (data['userNotifyStatus'] = userNotifyStatus);
    const fd = qs.stringify(data);

    let url = `${CPDFURI}/api/users/notify?access-token=${store.userStore.token}`;

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    try {
      let result = await axios.put(url, fd, config);

      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: updateUserNotify -> error", error)
      return Promise.resolve(error);
    }
  }
  //get_survey_nps
  getSurveyNPS = async()=>{
    return
    let CPDFURI = '';
    try {
      CPDFURI = await baseUrlApis.getBaseUrlBy(URL_CWS_API);
    } catch (error) {
      throw error;
    }
    if(!window.__online__ || !store.userStore.token){
      return Promise.resolve({});
    }
    let url = `${CPDFURI}/cpdfapi/v1/survey/nps?access-token=${store.userStore.token}`;
    try {
      let result = await axios.get(url);
      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: getSurveyNPS -> error", error)
      return Promise.resolve(error);
    }
  }
  updateSurveyNPS = async (params)=>{
    return
    let CPDFURI = '';
    try {
      CPDFURI = await baseUrlApis.getBaseUrlBy(URL_CWS_API);
    } catch (error) {
      throw error;
    }
    let data = {...params};
    const fd = qs.stringify(data);
    let url = `${CPDFURI}/cpdfapi/v1/survey/nps?access-token=${store.userStore.token}`;
    try {
      let result = await axios.post(url, fd);
      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: updateSurveyNPS -> error", error)
      return Promise.resolve(error);
    }
  }

  getUserExistBusinessData = async ({ token,baseUrl }) => {
    const CPDFURI = baseUrl ||  await baseUrlApis.getBaseUrlBy(URL_CWS_API);
    const url = `${CPDFURI}/cpdfapi/v1/users/exist-business-data?access-token=${token}`;
    try {
      const result = await axios.get(url).catch((err) => err);
      return Promise.resolve(result);
    } catch (error) {
      console.error("TCL: getUserExistBusinessData -> error", error)
      return Promise.resolve(error);
    }
  }
  async getRequestCode({codeID}){
    const CPDFURI = store.appStore.accountUrl;
    let data = {
      codeID,
    }
    let request = qs.stringify(data);
    let url = `${CPDFURI}/api/common/request-code?${request}`;
    let result = await axios.get(url);
    return result;
  }

  // check email or mobile exist
  checkAccountExist = async (account, isMobile = true) => {
    let CPDFURI = '';
    try {
        CPDFURI = store.appStore.accountUrl;
    } catch (error) {
        throw error;
    }
    const data = {
        userAccount: account,
        userAccountType: isMobile ? 2 : 1,
        'access-token': store.userStore.token
    }
    const fd = qs.stringify(data);
    let url = `${CPDFURI}/api/users/account-exists?${fd}`;
    try {
        let result = await axios.get(url);
        if (result && result.ret === 0) {
            return Promise.resolve(!!result.data.isExist);
        }
        return Promise.reject(result);
    } catch (error) {
        console.error("TCL: checkAccountExist -> error", error)
        return Promise.reject(error);
    }
  }

  // send email or mobile code
  sendVerificationCode = async (account, isMobile = true) => {
      let CPDFURI, url, token;
      try {
          CPDFURI = store.appStore.accountUrl;
      } catch (error) {
          throw error;
      }

      token = store.userStore.token;
      if (!token) {
          return Promise.reject('no token');
      }

      if (isMobile) {
          url = `${CPDFURI}/api/users/sms?access-token=${token}`
      } else {
          url = `${CPDFURI}/api/users/send-mail?access-token=${token}&al=${store.appStore.lng.full}`;
      }
      const data = {
          encrypt: account,
          module: isMobile ? 4 : 5,
      }
      try {
          let result = await axios.post(url, data);
          if (result && result.ret === 0) {
              return Promise.resolve(true);
          }
          return Promise.reject(result);
      } catch (error) {
          console.error("TCL: sendVerificationCode -> error", error)
          return Promise.reject(error);
      }
  }

  // set email or mobile
  setAccount = async (account, code, isMobile = true) => {
      let CPDFURI, url, token, data;
      try {
          CPDFURI = store.appStore.accountUrl;
      } catch (error) {
          throw error;
      }

      token = store.userStore.token;
      if (!token) {
          return Promise.reject('no token');
      }

      if (isMobile) {
          data = {
              mobile: account,
              verificationCode: code,
          }
          url = `${CPDFURI}/api/users/mobile?access-token=${token}`
      } else {
          data = {
              email: account,
              verificationCode: code,
              module: 5,
          }
          url = `${CPDFURI}/api/users/email?access-token=${token}`;
      }
      try {
          let result = await axios.put(url, data);
          if (result && result.ret === 0) {
              return Promise.resolve(true);
          }
          return Promise.reject(result);
      } catch (error) {
          console.error("TCL: setAccount -> error", error)
          return Promise.reject(error);
      }
  }
}
